import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CategoryDropdown from '@/components/CategoryDropdown';

const categoryButtons = [
  { label: 'cat_shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { label: 'cat_hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { label: 'cat_tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { label: 'cat_jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-windy-line' },
  { label: 'cat_pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-scissors-cut-line' },
  { label: 'cat_headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
  { label: 'cat_sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { label: 'cat_underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { label: 'cat_jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-line' },
  { label: 'cat_accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-keyboard-box-line' },
  { label: 'cat_bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
  { label: 'cat_belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { label: 'cat_perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { label: 'cat_other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const guideLinks = [
  {
    key: 'guide_review',
    to: '/reviews/cssbuy-review',
    img: 'https://readdy.ai/api/search-image?query=Sneaker%20closeup%20product%20inspection%20detail%20shot%20on%20clean%20background%20professional%20product%20photography&width=400&height=300&seq=guide-review&orientation=landscape',
  },
  {
    key: 'guide_shipping',
    to: '/shipping/cssbuy-shipping-cost',
    img: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20parcels%20stacked%20with%20tape%20labels%20clean%20product%20photography&width=400&height=300&seq=guide-shipping&orientation=landscape',
  },
  {
    key: 'guide_warehouse',
    to: '/warehouse/cssbuy-warehouse',
    img: 'https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20shelves%20and%20packages%20logistics%20clean%20aesthetic&width=400&height=300&seq=guide-warehouse&orientation=landscape',
  },
  {
    key: 'guide_qc',
    to: '/qc/cssbuy-qc-guide',
    img: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20of%20folded%20clothing%20on%20table%20with%20measuring%20and%20checklist%20professional&width=400&height=300&seq=guide-qc&orientation=landscape',
  },
  {
    key: 'guide_coupon',
    to: '/coupon/cssbuy-coupon',
    img: 'https://readdy.ai/api/search-image?query=Shopping%20discount%20sale%20tags%20and%20price%20tags%20with%20gift%20boxes%20clean%20retail%20product%20photography&width=400&height=300&seq=guide-coupon&orientation=landscape',
  },
  {
    key: 'guide_legit',
    to: '/reviews/is-cssbuy-legit',
    img: 'https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20shield%20and%20shopping%20bag%20on%20clean%20background%20modern&width=400&height=300&seq=guide-legit&orientation=landscape',
  },
];

const pillarArticles = [
  { title: 'How to Use CSSBuy Spreadsheet', desc: 'A step-by-step guide to searching, comparing, and verifying products.', to: '/guides/how-to-use-cssbuy-spreadsheet', img: 'https://readdy.ai/api/search-image?query=Laptop%20displaying%20spreadsheet%20data%20with%20fashion%20products%20on%20screen%20clean%20workspace&width=400&height=300&seq=pillar-howto&orientation=landscape' },
  { title: 'CSSBuy Spreadsheet Beginner Guide', desc: 'Everything new buyers need to know before their first order.', to: '/guides/cssbuy-spreadsheet-beginner-guide', img: 'https://readdy.ai/api/search-image?query=Person%20learning%20online%20shopping%20on%20laptop%20clean%20bright%20workspace%20beginner%20concept&width=400&height=300&seq=pillar-beginner&orientation=landscape' },
  { title: 'CSSBuy Shoes Spreadsheet', desc: 'Popular shoes, categories, and tips for finding the right pair.', to: '/spreadsheet/cssbuy-shoes-spreadsheet', img: 'https://readdy.ai/api/search-image?query=Stylish%20shoes%20collection%20displayed%20on%20clean%20white%20background%20product%20photography&width=400&height=300&seq=pillar-shoes&orientation=landscape' },
  { title: 'CSSBuy Sneakers Spreadsheet', desc: 'Discover sneakers, brands, and QC tips for sneaker buyers.', to: '/spreadsheet/cssbuy-sneakers-spreadsheet', img: 'https://readdy.ai/api/search-image?query=Trendy%20sneakers%20pair%20on%20minimal%20background%20streetwear%20product%20photography&width=400&height=300&seq=pillar-sneakers&orientation=landscape' },
  { title: 'CSSBuy Hoodies Spreadsheet', desc: 'Hoodie finds, sellers, and buying advice.', to: '/spreadsheet/cssbuy-hoodies-spreadsheet', img: 'https://readdy.ai/api/search-image?query=Folded%20hoodies%20stack%20in%20neutral%20colors%20clean%20product%20photography%20soft%20light&width=400&height=300&seq=pillar-hoodies&orientation=landscape' },
  { title: 'CSSBuy Taobao Guide', desc: 'How to browse and buy from Taobao through CSSBuy.', to: '/guides/cssbuy-taobao-guide', img: 'https://readdy.ai/api/search-image?query=Online%20marketplace%20shopping%20on%20smartphone%20with%20products%20clean%20modern%20concept&width=400&height=300&seq=pillar-taobao&orientation=landscape' },
  { title: 'CSSBuy Weidian Guide', desc: 'Weidian shopping tips and seller verification.', to: '/guides/cssbuy-weidian-guide', img: 'https://readdy.ai/api/search-image?query=Streetwear%20fashion%20items%20on%20hangers%20clean%20boutique%20product%20photography&width=400&height=300&seq=pillar-weidian&orientation=landscape' },
  { title: 'CSSBuy Yupoo Guide', desc: 'Understanding Yupoo catalogs and product links.', to: '/guides/cssbuy-yupoo-guide', img: 'https://readdy.ai/api/search-image?query=Product%20catalog%20photos%20grid%20with%20clothing%20items%20clean%20ecommerce%20concept&width=400&height=300&seq=pillar-yupoo&orientation=landscape' },
  { title: 'CSSBuy vs Superbuy', desc: 'A feature-by-feature comparison of two popular agents.', to: '/comparison/cssbuy-vs-superbuy', img: 'https://readdy.ai/api/search-image?query=Comparison%20concept%20with%20two%20shopping%20bags%20side%20by%20side%20clean%20balanced%20composition&width=400&height=300&seq=pillar-vs-superbuy&orientation=landscape' },
  { title: 'CSSBuy Alternatives', desc: 'Explore other buying agents and how they compare.', to: '/comparison/cssbuy-alternatives', img: 'https://readdy.ai/api/search-image?query=Multiple%20shopping%20options%20variety%20of%20retail%20products%20on%20clean%20background&width=400&height=300&seq=pillar-alternatives&orientation=landscape' },
];

const safetyItems = [
  'safety_verify_urls',
  'safety_verify_sellers',
  'safety_verify_price',
  'safety_verify_qc',
  'safety_verify_shipping',
  'safety_payments',
  'safety_passwords',
  'safety_customs',
  'safety_small_orders',
];

const faqItems = [
  { q: 'faq_q1', a: 'faq_a1' },
  { q: 'faq_q2', a: 'faq_a2' },
  { q: 'faq_q3', a: 'faq_a3' },
  { q: 'faq_q4', a: 'faq_a4' },
  { q: 'faq_q5', a: 'faq_a5' },
  { q: 'faq_q6', a: 'faq_a6' },
  { q: 'faq_q7', a: 'faq_a7' },
  { q: 'faq_q8', a: 'faq_a8' },
];

export default function Home() {
  const { t } = useTranslation('home');
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero Section */}
      <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Colorful%20sneakers%20and%20streetwear%20fashion%20collection%20arranged%20on%20clean%20white%20studio%20background%20vibrant%20product%20photography%20bright%20modern%20aesthetic&width=1600&height=900&seq=hero-main-2026&orientation=landscape&nocache=true"
            alt="CSSBuy Spreadsheet"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-24 pt-32">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-sm font-semibold tracking-widest text-white/80 uppercase mb-4">
              {t('hero_eyebrow')}
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              {t('hero_h1')}
            </h1>
            <p className="text-base md:text-lg text-white/90 leading-relaxed mb-8 max-w-2xl mx-auto">
              {t('hero_description')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-xl font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {t('btn_cssbuy_spreadsheet')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-accent-500 text-background-50 rounded-xl font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                {t('btn_buy_it_now')}
              </a>
              <CategoryDropdown />
            </div>

            <p className="text-sm text-white/70">{t('hero_trust')}</p>

            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-white/80">
              <span className="bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-lg">
                {t('independent_notice')}
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Search Section */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-6">
            {t('search_find_fast')}
          </h2>
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="flex-1 relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                type="text"
                placeholder={t('search_placeholder')}
                className="w-full pl-10 pr-4 py-3 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
              />
            </div>
            <button className="px-6 py-3 bg-primary-500 text-background-50 rounded-xl font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              {t('search_btn')}
            </button>
          </div>
          <div className="flex flex-wrap gap-2 mt-4 justify-center">
            {['search_filter_category', 'search_filter_platform', 'search_filter_product', 'search_filter_seller', 'search_filter_qc', 'search_filter_updated'].map((filter) => (
              <span key={filter} className="px-3 py-1.5 bg-background-100 border border-background-200 rounded-lg text-xs text-foreground-500">
                {t(filter)}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Category Buttons */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
            {t('categories_title')}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {categoryButtons.map((cat) => (
              <a
                key={cat.label}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center gap-2 p-4 bg-background-100 border border-background-200 rounded-xl hover:bg-primary-50 hover:border-primary-200 transition-all text-center"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center transition-colors">
                  <i className={`${cat.icon} text-primary-600 text-lg`}></i>
                </div>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700 leading-tight">
                  {t(cat.label)}
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* What is CSSBuy Spreadsheet */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                {t('whatis_title')}
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                {t('whatis_text')}
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-xl text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                {t('whatis_cta')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20fashion%20product%20grid%20flatlay%20with%20folded%20hoodies%20sneakers%20and%20accessories%20on%20neutral%20background%20clean%20minimal%20product%20photography&width=800&height=600&seq=whatis-2026&orientation=landscape&nocache=true"
                alt="CSSBuy Spreadsheet workspace"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-background-100/50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-10">
            {t('howitworks_title')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { step: '01', title: 'step1_title', desc: 'step1_desc', icon: 'ri-search-line' },
              { step: '02', title: 'step2_title', desc: 'step2_desc', icon: 'ri-exchange-line' },
              { step: '03', title: 'step3_title', desc: 'step3_desc', icon: 'ri-shield-check-line' },
              { step: '04', title: 'step4_title', desc: 'step4_desc', icon: 'ri-check-double-line' },
            ].map((item) => (
              <div key={item.step} className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 text-center">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-3">
                  <i className={`${item.icon} text-primary-600 text-xl`}></i>
                </div>
                <span className="text-xs font-bold text-primary-500">{item.step}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1 mb-1">{t(item.title)}</h3>
                <p className="text-xs text-foreground-500">{t(item.desc)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Spreadsheet Table */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6">
            {t('featured_title')}
          </h2>
          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead className="bg-background-100">
                <tr>
                  {['featured_product', 'featured_category', 'featured_platform', 'featured_seller', 'featured_qc', 'featured_updated', 'featured_action'].map((header) => (
                    <th key={header} className="px-4 py-3 text-left text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                      {t(header)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200">
                {[
                  ['Nike Dunk Low', 'Shoes', 'Taobao', 'Top Seller', 'Available', '2026-08-30'],
                  ['Travis Scott Hoodie', 'Hoodies', 'Weidian', 'Verified', 'Available', '2026-08-28'],
                  ['Supreme T-Shirt', 'T-Shirts', 'Yupoo', 'Verified', 'Available', '2026-08-27'],
                  ['Palace Jacket', 'Jackets', 'Taobao', 'Top Seller', 'Check', '2026-08-25'],
                  ['Chrome Hearts Bag', 'Bags', 'Weidian', 'Verified', 'Available', '2026-08-24'],
                ].map((row, idx) => (
                  <tr key={idx} className="hover:bg-background-100/50 transition-colors">
                    {row.map((cell, cIdx) => (
                      <td key={cIdx} className="px-4 py-3 text-sm text-foreground-700">
                        {cIdx === 6 ? (
                          <span className="text-xs text-foreground-500">{t('featured_verify')}</span>
                        ) : (
                          cell
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-4 text-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              {t('featured_cta')}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Guides */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-background-100/50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8">
            {t('guides_title')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {guideLinks.map((guide) => (
              <Link
                key={guide.to}
                to={guide.to}
                className="group overflow-hidden bg-background-50 border border-background-200 rounded-xl hover:border-primary-200 hover:bg-primary-50/40 transition-all"
              >
                <div className="h-36 overflow-hidden">
                  <img
                    src={guide.img}
                    alt={t(guide.key)}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center shrink-0 transition-colors">
                    <i className="ri-book-open-line text-primary-600 text-base"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 leading-tight">
                    {t(guide.key)}
                  </span>
                  <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Pillar Articles */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-3">
            {t('pillar_title')}
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 max-w-2xl mx-auto">
            {t('hero_trust')}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {pillarArticles.map((article) => (
              <Link
                key={article.to}
                to={article.to}
                className="group overflow-hidden bg-background-100 border border-background-200 rounded-xl hover:border-primary-200 hover:bg-primary-50/40 transition-all flex flex-col"
              >
                <div className="h-32 overflow-hidden">
                  <img
                    src={article.img}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 leading-snug mb-1">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3">{article.desc}</p>
                  <span className="mt-auto inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                    Read more
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6">
            {t('safety_title')}
          </h2>
          <div className="bg-accent-50 border border-accent-200 rounded-xl p-4 md:p-6 mb-6">
            <h3 className="text-sm font-bold text-accent-800 uppercase tracking-wider mb-2">
              {t('safety_notice')}
            </h3>
            <p className="text-sm text-accent-700">{t('safety_disclaimer')}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {safetyItems.map((item) => (
              <div key={item} className="flex items-center gap-2.5 p-3 bg-background-100 border border-background-200 rounded-lg">
                <i className="ri-shield-check-line text-primary-600 text-lg"></i>
                <span className="text-sm text-foreground-700">{t(item)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-background-100/50">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8">
            {t('faq_title')}
          </h2>
          <div className="space-y-3">
            {faqItems.map((faq, index) => (
              <div key={index} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900">{t(faq.q)}</span>
                  <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${openFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {t(faq.a)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl overflow-hidden mb-8">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20boutique%20fashion%20retail%20store%20interior%20with%20clothing%20racks%20sneakers%20display%20warm%20ambient%20lighting%20stylish%20aesthetic&width=1200&height=500&seq=cta-2026&orientation=landscape&nocache=true"
              alt="CSSBuy Spreadsheet CTA"
              className="w-full h-48 md:h-64 object-cover"
            />
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6">
            {t('final_cta_title')}
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-xl font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('final_cta_button')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-accent-500 text-background-50 rounded-xl font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              {t('btn_buy_it_now')}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}